import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PdfViewerFullScreenRoutingModule } from './pdf-viewer-full-screen-routing.module';
import { PdfViewerFullScreenComponent } from './pdf-viewer-full-screen.component';
import { SharedModule } from '@app/commons/sharad.module';
import { ComponentsModule } from '@app/components/components.module';


@NgModule({
  declarations: [
    PdfViewerFullScreenComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    PdfViewerFullScreenRoutingModule
  ]
})
export class PdfViewerFullScreenModule { }
